// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"665":"27ed20c3c3396b6c","670":"c028d66a951f7984"}[chunkId] + ".js";
};